import GenericError from 'pages/Authorize/Errors/GenericError';

import { Code } from './styles';

const InvalidSandboxApplication = () => (
  <GenericError buttonLabel="Try Again" title="Invalid Client">
    Please use the <Code>client_id</Code> of your sandbox application to create
    sandbox connections.
  </GenericError>
);

export default InvalidSandboxApplication;
